import Vue from 'vue'
import Label from './DpIndex.vue'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// import zhCn from 'element-plus/dist/locale/zh-cn'

// 动态构造组件
function mountComponent(RootComponent, props)
{
  // const app = createApp(RootComponent, props)

  // app.use(ElementPlus, { locale: zhCn })
  // const root = document.createElement('div')
  // document.body.appendChild(root)
  // return {
  //   instance: app.mount(root),
  //   unmount()
  //   {
  //     document.body.removeChild(root)
  //   }
  // }
  const comp = new (Vue.extend(RootComponent))({ propsData: props }).$mount()
  document.body.appendChild(comp.$el)
  comp.remove = () =>
  {
    document.body.removeChild(comp.$el)
    comp.$destroy()
  }
 
  return comp
}

export default class Popup
{
  constructor(val)
  {
    this.viewer = val.viewer
    this.position = val.position

    this.vmInstance = mountComponent(Label, {
      title: val.title,
      formList: val.formList,
      metadata: val.metadata,
      btnList: val.btnList
    }) // 根据模板创建一个组件实例

    this.vmInstance.closeEvent = e =>
    {
      this.windowClose()
      val.closeBack()
    }

    val.viewer._widgetContainer.appendChild(this.vmInstance.$el) // 将字符串模板生成的内容添加到DOM上
    this.addPostRender()
  }
     
  // 添加场景事件
  addPostRender()
  {
    this.viewer.scene.postRender.addEventListener(this.postRender, this)
  }
 
  // 场景渲染事件 实时更新窗口的位置 使其与笛卡尔坐标一致
  postRender()
  {
    if (!this.vmInstance.$el || !this.vmInstance.$el.style) return
    const canvasHeight = this.viewer.scene.canvas.height
    const windowPosition = new window.Cesium.Cartesian2()
    window.Cesium.SceneTransforms.wgs84ToWindowCoordinates(
      this.viewer.scene,
      this.position,
      windowPosition
    )
    this.vmInstance.$el.style.bottom =
       canvasHeight - windowPosition.y + 20 + 'px'
    const elWidth = this.vmInstance.$el.offsetWidth
    this.vmInstance.$el.style.left = windowPosition.x - elWidth / 2 + 'px'
 
    const camerPosition = this.viewer.camera.position
    let height = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(camerPosition).height
    height += this.viewer.scene.globe.ellipsoid.maximumRadius

    if ((!(window.Cesium.Cartesian3.distance(camerPosition, this.position) > height)) && this.viewer.camera.positionCartographic.height < 50000000)
      this.vmInstance.$el.style.display = 'block'
    else
      this.vmInstance.$el.style.display = 'none'
  }

  // 关闭
  windowClose()
  {
    if (this.vmInstance)
    
      this.vmInstance.$el.remove()
      // this.vmInstance.unmount()
    
    this.viewer.scene.postRender.removeEventListener(this.postRender, this) // 移除事件监听
  }
}



// WEBPACK FOOTER //
// ./src/plugins/app/assembly/kyxxyzt/popup/DpIndex.js